import React, { useState } from "react";
import "./StaffTable.css";
import { FiEdit, FiTrash } from "react-icons/fi";
// import EditRoleModal from "../EditRoleModal/EditRoleModal";
// import DeleteRoleModal from "./DeleteRoleModal/DeleteRoleModal";
// import { DeleteRoleAPI } from "../../../utils/APIs/RoleApis";
// import { toast } from "react-toastify";
import EditStaffModal from "../EditStaffModal/EditStaffModal";
import DeleteStaffModal from "./DeleteStaffModal/DeleteStaffModal";

const StaffTable = ({ data = [],page,limit ,refreshData }) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null);
    // const [deleting, setDeleting] = useState(false);

    const handleEdit = (role) => {
        setSelectedRole(role);
        setShowModal(true);
    };

    const handleDelete = (role) => {
        setSelectedRole(role);
        setShowDeleteModal(true);
    };

    // const confirmDelete = async () => {
    //     if (!selectedRole?._id) return;

    //     try {
    //         // setDeleting(true);

    //         const response = await DeleteRoleAPI(selectedRole._id);
    //         if (response?.data?.success) {
    //             toast.success(response?.data?.message || "Role Deleted successfully!")
    //             setShowDeleteModal(false);
    //             refreshData(); // refresh table after delete
    //         }
    //         else {
    //             toast.error(response?.data?.message || "Role not deleting")
    //         }


    //     } catch (error) {
    //         console.error("Delete role failed:", error);
    //     } finally {
    //         // setDeleting(false);
    //     }
    // };

    return (
        <div className="role-table-wrapper">
            <table className="role-table">
                <thead>
                    <tr>
                        <th className="td-sr">Sr.</th>
                        <th>Staff Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Last Login</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>

                <tbody>

                    {data.length > 0 ? (
                        data.map((item, index) => (
                            <tr key={item._id}>
                                <td className="td-sr">{(page - 1) * limit + index + 1}</td>
                                <td>{item.name || "-"}</td>
                                <td>{item.email || "-"}</td>
                                    <td>{item.role || "-"}</td>
                                <td>
                                    {item.lastLogin
                                        ? new Date(item.lastLogin).toLocaleString("en-IN", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                        })
                                        : "-"}
                                </td>

                                <td>{item.status || "-"}</td>
                                <td className="action-col">
                                    <button
                                        className="chat-btn edit-btn"
                                        onClick={() => handleEdit(item)}
                                    >
                                        <FiEdit size={16} />
                                    </button>

                                    <button
                                        className="chat-btn delete-btn"
                                        onClick={() => handleDelete(item)}
                                    >
                                        <FiTrash size={16} />
                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                                No roles available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

           <EditStaffModal
  isOpen={showModal}
  staff={selectedRole}
  onClose={() => setShowModal(false)}
  refreshData={refreshData}
/>

<DeleteStaffModal
  isOpen={showDeleteModal}
  staff={selectedRole}
  onClose={() => setShowDeleteModal(false)}
  refreshData={refreshData}
/>

        </div>
    );
};

export default StaffTable;